export default "__VITE_ASSET__5224ab77__"